import Video from '../components/Video'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  deregisterVideoPlayer,
  pause,
  play,
  registerVideoPlayer
} from '../actions/videoPlayerActions'

class VideoContainer extends Component {
  static propTypes = {
    deregisterVideoPlayer: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    listeners: PropTypes.object,
    onPause: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    paused: PropTypes.bool,
    registerVideoPlayer: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.registerVideoPlayer()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.paused !== this.props.paused && this.props.paused) {
      this.video.pause()
    }
  }

  componentWillUnmount() {
    this.props.deregisterVideoPlayer()
  }

  onPlay(propListener) {
    this.props.onPlay()
    propListener && propListener()
  }

  onPause(propListener) {
    this.props.onPause()
    propListener && propListener()
  }

  getVideo() {
    return this.video
  }

  render() {
    const { listeners = {}, ...videoProps } = this.props
    listeners.play = this.onPlay.bind(this, listeners.play)
    listeners.pause = this.onPause.bind(this, listeners.pause)

    return (
      <Video
        ref={ref => {
          this.video = ref
        }}
        listeners={listeners}
        {...videoProps}
      />
    )
  }
}

const mapStateToProps = (state, props) => ({
  paused: Boolean((state.videoPlayers[props.id] || {}).paused)
})

const mapDispatchToProps = (dispatch, { id }) => ({
  deregisterVideoPlayer: () => dispatch(deregisterVideoPlayer(id)),
  registerVideoPlayer: () => dispatch(registerVideoPlayer(id)),
  onPause: () => dispatch(pause(id)),
  onPlay: () => dispatch(play(id))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    withRef: true
  }
)(VideoContainer)



// WEBPACK FOOTER //
// ../src/containers/VideoContainer.js